module.exports = __webpack_public_path__ + "img/logo_building_smart.683dcf21.png";